module.exports = __webpack_public_path__ + "static/logo_hhm-31651a9f59ff4a991cfe6b81b1f3d44a.png";